module.exports = __webpack_public_path__ + "img/experiences_L.5359de25.jpg";